import Head from 'next/head';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Link from 'next/link';


function Disclaimer() {
  return (
    <div>

      <Head>
        <title>Lindle Disclaimer</title>
        <meta name="description" content="Developer libraries that can used to add functionality to 3rd party apps" />
        <link rel="icon" href="/favicon.ico" />

        {/* Facebook */}
        <meta property="og:title" content="Lindle" />
        <meta property="og:description" content="Developer libraries that can used to add functionality to 3rd party apps" />
        <meta property="og:image" content="/logoText.png" />
        <meta property="og:url" content="https://lindle.vercel.app" />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content="Lindle" />
        <meta name="twitter:description" content="Developer libraries that can used to add functionality to 3rd party apps" />
        <meta name="twitter:image" content="/logoText.png" />
        <meta name="twitter:card" content="/bannerText.png" />

        {/* pinterest */}
        <meta name="pinterest-rich-pin" content="true" />
      </Head>

      {/* Navigation */}
      <Navigation />

      {/* Main Content Section */}
      <main className="container mx-auto my-8 p-8 bg-white shadow-lg rounded-lg">

        {/* Content Heading */}
        <h1 className="text-3xl font-bold mb-6">Disclaimer</h1>

        {/* Introduction Section */}
        <section className="mb-6">
          <p>
            Welcome to Lindle! This disclaimer governs your use of our website; by using our website, you accept this disclaimer in full. If you disagree with any part of this disclaimer, you must not use our website.
          </p>
        </section>

        {/* No Warranties Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. No Warranties</h2>
          <p>
            This website is provided &quot;as is&quot; without any representations or warranties, express or implied. We make no representations or warranties in relation to this website or the information and materials provided on this website.
          </p>
        </section>

        {/* Limitation of Liability Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Limitation of Liability</h2>
          <p>
            We will not be liable to you (whether under the law of contact, the law of torts, or otherwise) in relation to the contents of, or use of, or otherwise in connection with, this website:
            <ul className="list-disc pl-8">
              <li>to the extent that the website is provided free-of-charge, for any direct loss;</li>
              <li>for any indirect, special, or consequential loss; or</li>
              <li>for any business losses, loss of revenue, income, profits, or anticipated savings, loss of contracts or business relationships, loss of reputation or goodwill, or loss or corruption of information or data.</li>
            </ul>
          </p>
        </section>

        {/* External Links Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. External Links</h2>
          <p>
            This website may contain links to external websites that are not provided or maintained by or in any way affiliated with us. Please note that we do not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
          </p>
        </section>

        {/* Contact Information Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Contact Information</h2>
          <p>
            If you have any questions or concerns regarding this disclaimer, please contact us at <b><Link href="mailto:m2kdevelopments@gmail.com">m2kdevelopments@gmail.com</Link></b>.
          </p>
        </section>

      </main>

      <Footer />
    </div>
  )
}

export default Disclaimer